import React from 'react';
import { BaseFieldLayoutProps } from 'ui-builder';

export default function TextFieldLayout(props: BaseFieldLayoutProps) {
  return (
    <span>{props.value || props.noDataMessage}</span>
  );
}
